import Vue from 'vue'

export async function getDisponibilidad(context, [access_token, fecha_inicial, fecha_final]) {
    try {
        if (access_token) {
            const response = await Vue.axios({
                method: 'GET',
                url: '/disponibilidad',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
                params: {
                    fecha_inicial,
                    fecha_final,
                }
            })
            context.commit('disponibilidad/setDisponibilidad', response.data, { root: true })
        }

    } catch (e) {
    } finally {
        
    }
}

